export const testCardOptions = [
  { label: 'Good Card', value: 'cnon:card-nonce-ok'},
  { label: 'CVV incorrect', value: 'cnon:card-nonce-rejected-cvv'},
  { label: 'Postal Code incorrect', value: 'cnon:card-nonce-rejected-postalcode'},
  { label: 'Card Expiration incorrect', value: 'cnon:card-nonce-rejected-expiration'},
  { label: 'Card Declined', value: 'cnon:card-nonce-declined'},
];